let html = `<div class="player-footer-card">
    <div class="player-footer-card__left">
        <div class="player-footer-card__poster">
            <img class="player-footer-card__poster-img" />
        </div>
    </div>
    <div class="player-footer-card__body">
        <div class="player-footer-card__title"></div>
        <div class="player-footer-card__tags"></div>
        <div class="player-footer-card__text"></div>
    </div>
</div>`

export default html